import { Component, inject } from '@angular/core';
import {ModalService} from '@services/modal.service';


@Component({
  selector: 'app-error-modal',
  standalone: true,
  template: `
    @if (errorService.isOpen()) {
      <div class="modal-backdrop">
        <div class="modal-content">
          <h3 class="pb-3">{{ errorService.errorTitle() }}</h3>
          <p class="pb-5">{{ errorService.errorMessage() }}</p>
          <button class="button" (click)="errorService.closeMessage()">Chiudi</button>
        </div>
      </div>
    }
  `,
  styles: [`
    p { min-height: 200px; align-content: center; }
    .modal-backdrop { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 1000; }
    .modal-content { min-height: 250px; min-width: 500px; background: white; padding: 20px; border-radius: 8px; max-width: 400px; text-align: center; border: 2px solid #004679; }
  `]
})
export class ModalComponent {
  protected errorService = inject(ModalService);
}
